import { useIonModal } from '@ionic/react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '@components/DeleteConfirmationAlert.module.css';
import FormButtons from '@components/fields/FormButtons';
import BodyCopy from '@components/typography/BodyCopy';
import Heading2 from '@components/typography/Heading2';
import { Opener } from '@hooks/useOpener';

type Props = {
  onCancel?: () => void;
  onDelete: () => void;
  opener: Opener;
};

type ModalBodyProps = {
  onCancel: () => void;
  onDelete: () => void;
};

const ModalBody = ({ onCancel, onDelete }: ModalBodyProps) => (
  <div className={styles.modalInsides}>
    <div className={styles.headingSpacing}>
      <Heading2>
        <FormattedMessage id="pages.client.account.confirmDeletion.heading" />
      </Heading2>
    </div>

    <BodyCopy>
      <FormattedMessage id="pages.client.account.confirmDeletion.preamble" />
      <ul>
        <li>
          <FormattedMessage id="pages.client.account.confirmDeletion.whatGetsDeleted1" />
        </li>
        <li>
          <FormattedMessage id="pages.client.account.confirmDeletion.whatGetsDeleted2" />
        </li>
        <li>
          <FormattedMessage id="pages.client.account.confirmDeletion.whatGetsDeleted3" />
        </li>
      </ul>
      <FormattedMessage id="pages.client.account.confirmDeletion.postamble" />
    </BodyCopy>
    <div className={styles.buttons}>
      <FormButtons
        cancelKey="dictionary.cancel"
        narrowMargin
        onCancel={onCancel}
        onSave={onDelete}
        saveKey="pages.client.account.confirmDeletion.deleteButton"
        skipValid
      />
    </div>
  </div>
);

const DeleteAccountConfirmation = ({ onCancel, onDelete, opener }: Props) => {
  const [presentModal, dismissModal] = useIonModal(ModalBody, {
    onCancel: onCancel ?? opener.close,
    onDelete: () => {
      opener.close();
      onDelete();
    }
  });

  useEffect(() => {
    if (opener.isOpen) {
      presentModal({
        backdropDismiss: false,
        cssClass: 'fitToContent',
        onDidDismiss: opener.close
      });
    } else {
      dismissModal();
    }
  }, [dismissModal, opener.close, opener.isOpen, presentModal]);

  return <></>;
};

export default DeleteAccountConfirmation;
